import { render } from "./OtherManage.vue?vue&type=template&id=7874c473"
import script from "./OtherManage.vue?vue&type=script&lang=js"
export * from "./OtherManage.vue?vue&type=script&lang=js"

import "./OtherManage.vue?vue&type=style&index=0&id=7874c473&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__